import { render } from "./powerupClass.vue?vue&type=template&id=975ce4ae&scoped=true&ts=true"
import script from "./powerupClass.vue?vue&type=script&lang=ts"
export * from "./powerupClass.vue?vue&type=script&lang=ts"

import "./powerupClass.vue?vue&type=style&index=0&id=975ce4ae&lang=scss&scoped=true"

import exportComponent from "C:\\PROJEKTE\\GAMES\\shootEm\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-975ce4ae"]])

export default __exports__